import {PaginatedResult} from "../../models/requests/paginated-result/paginated.result";
import {apiService} from "../api.service";
import {PaginatedRequest} from "../../models/requests/paginated-request/paginated.request";
import {Statement, StatementSummary} from "../../models/accounting/statements";

export class StatementsService {
    public async getList(request: PaginatedRequest): Promise<PaginatedResult<Statement>> {
        return (await apiService.get<PaginatedResult<Statement>>(
            "accounting/statements",
            {
                params: request.toParams()
            }
        )).data;
    }

    public async getSummary(): Promise<StatementSummary> {
        return (await apiService.get<StatementSummary>("accounting/statements/summary")).data;
    }
}

export const statementsService = new StatementsService();

